<template>
  <div class="row">
    <div class="columns">
      <CampaignStatsFilters @filterChanged="filterChanged" />
    </div>
    <div class="columns shrink">
      <StrokeButton
        plain
        size="small"
        type="primary"
        :disabled="!isPrimaryTypeSelected"
        @click="saveCSV"
      >
        {{ $t('EXPORT_CSV') }}
      </StrokeButton>
    </div>
  </div>
</template>

<script>
import FileSaver from 'file-saver';

import { AdInsight } from '@/api/api';

import CampaignStatsFilters from './CampaignStatsFilters';

import campaignId from '@/mixins/advertisement/campaignId';

import StrokeButton from '../../../common/StrokeButton';

export default {
  name: 'CampaignStatsHeader',
  components: {
    CampaignStatsFilters,
    StrokeButton,
  },
  mixins: [campaignId],
  data() {
    return {
      filters: {
        range: '',
        bids: [],
        chart: [],
      },
    };
  },
  computed: {
    isPrimaryTypeSelected() {
      return Boolean(this.filters.chart.length);
    },
  },
  methods: {
    filterChanged(filters) {
      this.setFilters(filters);

      this.$emit('filterChanged', filters);
    },
    setFilters({ range, bids, chart }) {
      this.filters.bids = bids;
      this.filters.range = range;
      this.filters.chart = chart;
    },
    saveCSV() {
      const { range, bids, chart } = this.filters;

      return AdInsight.saveStatsBuilderCSV({
        campaignId: this.campaignId,
        bids,
        range,
        statType: chart,
      }).then(file => {
        FileSaver.saveAs(file, file.name);
      });
    },
  },
};
</script>
